import Vue from 'vue'
import PortalVue from 'portal-vue'
import { ToastPlugin, ModalPlugin, VBTogglePlugin } from 'bootstrap-vue'

import VueCompositionAPI from '@vue/composition-api'
import commonmixins from '@/mixins/commonmixins'
import Vuesax from 'vuesax'
import auth_controller from './router/auth_controller'

import router from './router'
import store from './store'
import App from './App.vue'

// Global Components
import './global-components'

// 3rd party plugins
import '@/libs/portal-vue'
import '@/libs/toastification'

// document.addEventListener("contextmenu", (event) => event.preventDefault());

import 'vuesax/dist/vuesax.css'

document.addEventListener('contextmenu', event => event.preventDefault())

document.addEventListener('keydown', event => {
  if (event.ctrlKey && event.shiftKey && event.code === 'KeyC') {
    event.preventDefault()
  }
  if (event.ctrlKey && event.shiftKey && event.code === 'KeyI') {
    event.preventDefault()
  }
  if (event.ctrlKey && event.code === 'KeyU') {
    event.preventDefault()
  }
})

Vue.mixin(commonmixins) // Vuesax
Vue.use(Vuesax)

// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)
Vue.use(VBTogglePlugin)
// Composition API
Vue.use(VueCompositionAPI)

Vue.use(PortalVue)
// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')
require('@/assets/scss/home.scss')

Vue.config.productionTip = false

auth_controller.init(router, store)

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
